import { createSelector, createFeatureSelector } from '@ngrx/store';
import { Crop, CropsState } from 'src/app/shared/model';

import { adapter } from './crops.reducer';

const {
  // selectIds,
  selectEntities,
  selectAll,
  // selectTotal
} = adapter.getSelectors();

export const getCropsState = createFeatureSelector<CropsState>('crops');

export const getCropsEntities = createSelector(getCropsState, selectEntities);

export const getCrops = createSelector(getCropsState, selectAll);

export const getCrop = createSelector(
  getCropsEntities,
  (crops: { [key: string]: Crop }, props: { id: string }) => crops[props.id],
);
